import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function PrivateRoute({ children }) {
  const { currentUser } = useAuth();

  // If there's no user, redirect them to the login page
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // If there is a user, show the page content
  return children;
}